<template>
  <footer
    class="bg-gray-800 border-t border-gray-700 text-gray-300 py-3 mt-auto"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div
        class="flex flex-col sm:flex-row justify-between items-center sm:items-start"
      >
        <!-- Kompanija info -->
        <div class="mb-2 sm:mb-0 text-center sm:text-left">
          <div>
            <div class="text-xs font-medium text-white mb-0.5">
              Pratite nas na Instagramu:
            </div>
            <a
              href="https://www.instagram.com/mojagarderoba_/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-400 hover:text-pink-400 transition-colors text-xs flex items-center cursor-pointer justify-center sm:justify-start"
            >
              <svg
                class="mr-1 h-3 w-3"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
              @mojagarderoba_
            </a>
          </div>
        </div>

        <!-- Kontakt info -->
        <div class="text-center sm:text-right">
          <!-- Kontakt email -->
          <div class="mb-2">
            <div class="text-xs font-medium text-white mb-0.5">
              Kontakt email:
            </div>
            <button
              @click="copyEmailToClipboard"
              class="text-gray-400 hover:text-indigo-400 transition-colors text-xs flex items-center cursor-pointer justify-center sm:justify-end"
              :class="{ 'text-indigo-400': copied }"
            >
              devfinity.solutions.contact@gmail.com
              <svg
                v-if="copied"
                class="ml-1 h-3 w-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </button>
          </div>

          <!-- Telegram grupa -->
          <div>
            <div class="text-xs font-medium text-white mb-0.5">
              Pridružite se našoj zajednici:
            </div>
            <a
              href="https://t.me/+JyMhg0qKX6hiYzA0"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-400 hover:text-blue-400 transition-colors text-xs flex items-center cursor-pointer justify-center sm:justify-end"
            >
              <svg
                class="mr-1 h-3 w-3"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"
                />
              </svg>
              Telegram grupa
            </a>
          </div>
        </div>
      </div>

      <!-- Copyright -->
      <div class="mt-2 pt-1 border-t border-gray-700 text-center">
        <p class="text-gray-500 text-xs">
          &copy; {{ currentYear }} Devfinity Solutions. All rights reserved.
        </p>
      </div>
    </div>

    <!-- Toast notifikacija -->
    <div
      v-if="showToast"
      class="fixed bottom-5 right-5 bg-gray-900 text-white px-3 py-1.5 rounded shadow-lg transition-opacity duration-300 text-xs"
      :class="{ 'opacity-0': toastFading }"
    >
      Email adresa je kopirana u clipboard!
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear());
    const copied = ref(false);
    const showToast = ref(false);
    const toastFading = ref(false);

    const copyEmailToClipboard = () => {
      const email = 'devfinity.solutions.contact@gmail.com';
      navigator.clipboard
        .writeText(email)
        .then(() => {
          // Prikaži znak za potvrdu
          copied.value = true;
          showToast.value = true;

          // Resetuj nakon 2 sekunde
          setTimeout(() => {
            toastFading.value = true;
            setTimeout(() => {
              copied.value = false;
              showToast.value = false;
              toastFading.value = false;
            }, 300);
          }, 2000);
        })
        .catch((err) => {
          console.error('Nije moguće kopirati tekst: ', err);
        });
    };

    return {
      currentYear,
      copyEmailToClipboard,
      copied,
      showToast,
      toastFading,
    };
  },
});
</script>
